
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { BindPhone, BindWechat } from '@/api/user'

@Component
export default class BindAccountDialog extends Vue {
  @Prop({ default: false }) public visible!: boolean
  @Prop({ default: '' }) public bindType!: string

  public dialogVisible = false
  public loading = false
  public formData = {
    phone: '',
    code: ''
  }

  // 响应式布局属性
  get dialogWidth() {
    return window.innerWidth < 768 ? '95%' : '30%'
  }

  get formLabelWidth() {
    return window.innerWidth < 768 ? '70px' : '80px'
  }

  public rules = {
    phone: [
      { required: true, message: '请输入手机号', trigger: 'blur' },
      { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
    ],
    code: [
      { required: true, message: '请输入验证码', trigger: 'blur' },
      { min: 4, max: 6, message: '验证码长度不正确', trigger: 'blur' }
    ]
  }

  // 验证码按钮相关
  public codeBtnDisabled = false
  public countdown = 60
  public timer: number | null = null
  public codeButtonText = '获取验证码'

  // 微信绑定相关
  public wechatBindStatus = '等待扫描...'

  get dialogTitle(): string {
    return this.bindType === 'phone' ? '绑定手机号' : '绑定微信'
  }

  @Watch('visible')
  onVisibleChange(val: boolean) {
    this.dialogVisible = val
    if (val) {
      this.resetForm()
      if (this.bindType === 'wechat') {
        this.initWechatQRCode()
      }
    } else {
      this.clearTimer()
    }
  }

  @Watch('dialogVisible')
  onDialogVisibleChange(val: boolean) {
    if (!val) {
      this.$emit('update:visible', false)
    }
  }

  public resetForm() {
    this.formData = {
      phone: '',
      code: ''
    }
    this.codeBtnDisabled = false
    this.codeButtonText = '获取验证码'
    this.clearTimer()

    // 重置表单验证
    if (this.$refs.form) {
      (this.$refs.form as any).resetFields()
    }
  }

  public clearTimer() {
    if (this.timer) {
      window.clearInterval(this.timer)
      this.timer = null
    }
  }

  public handleSendCode() {
    // 验证手机号
    const phoneRule = this.rules.phone[1]
    const phonePattern = phoneRule.pattern as RegExp
    if (!phonePattern.test(this.formData.phone)) {
      this.$message.error('请输入正确的手机号')
      return
    }

    // 发送验证码逻辑
    // 这里应该调用发送验证码的API
    this.$message.success('验证码已发送，请注意查收')

    // 开始倒计时
    this.codeBtnDisabled = true
    this.countdown = 60
    this.codeButtonText = `${this.countdown}秒后重新获取`

    this.timer = window.setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--
        this.codeButtonText = `${this.countdown}秒后重新获取`
      } else {
        this.codeBtnDisabled = false
        this.codeButtonText = '获取验证码'
        this.clearTimer()
      }
    }, 1000)
  }

  public initWechatQRCode() {
    // 初始化微信二维码
    // 这里应该调用获取微信二维码的API
    // 然后监听扫码状态
    this.wechatBindStatus = '等待扫描...'

    // 模拟二维码扫描过程
    setTimeout(() => {
      this.wechatBindStatus = '扫描成功，等待确认...'

      setTimeout(() => {
        this.wechatBindStatus = '绑定成功！'

        setTimeout(() => {
          // 绑定成功后关闭对话框并刷新用户信息
          this.handleBindWechatSuccess()
        }, 1000)
      }, 2000)
    }, 3000)
  }

  public async handleSubmit() {
    if (this.bindType !== 'phone') return

    try {
      const valid = await (this.$refs.form as any).validate()
      if (!valid) return

      this.loading = true
      const bindData= {
        phone: this.formData.phone,
        code: this.formData.code
      }
      await BindPhone(bindData)
      this.$message.success('手机号绑定成功')
      this.$emit('success')
      this.dialogVisible = false
    } catch (error) {
      console.error('绑定手机号失败:', error)
      this.$message.error('绑定手机号失败，请重试')
    } finally {
      this.loading = false
    }
  }

  public handleBindWechatSuccess() {
    // 模拟微信绑定成功
    const bindData = {
      code: 'mock_wechat_code'
    }

    // 实际项目中应该在扫码成功后由后端回调，前端不需要主动调用bindWechat
    // 这里仅作为示例
    BindWechat(bindData).then(() => {
      this.$message.success('微信绑定成功')
      this.$emit('success')
      this.dialogVisible = false
    }).catch(error => {
      console.error('绑定微信失败:', error)
      this.$message.error('绑定微信失败，请重试')
    })
  }

  beforeDestroy() {
    this.clearTimer()
  }
}
